import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/propertyGroups/propertyGroupQueryKeys.ts
var t = e("propertyGroups", {
	list: (e) => e ? ["list", e] : ["list"],
	detail: (e) => ["detail", e]
});
//#endregion
export { t as propertyGroupQueryKeys };
